import React from "react"
import { useParams } from "react-router-dom"

import { connect } from "scrivito"
import { RJSFFormContextProvider } from "shared/ui/rjsf-form/RJSFFormContext"

import { useProductConfigurationPageModel } from "./model/useProductConfigurationPageModel"
import { ProductConfigurationPageView } from "./ui/ProductConfigurationPageView"

export interface ProductConfigurationPageProps {
  variantKey: string
}

function ProductConfigurationPageComponentInner(
  props: ProductConfigurationPageProps
) {
  return (
    <ProductConfigurationPageView
      {...useProductConfigurationPageModel(props)}
    />
  )
}

const ConnectedProductPageComponentInner = connect(
  ProductConfigurationPageComponentInner
)

function ProductConfigurationPageComponent() {
  const { variantKey } = useParams()
  if (!variantKey) {
    throw new Error("Missing variantKey!")
  }

  return (
    <RJSFFormContextProvider>
      <ConnectedProductPageComponentInner variantKey={variantKey} />
    </RJSFFormContextProvider>
  )
}

export const ProductConfigurationPage = React.memo(
  connect(ProductConfigurationPageComponent)
) as unknown as typeof ProductConfigurationPageComponent
